import { render, staticRenderFns } from "./PFiles.vue?vue&type=template&id=3b95598a&scoped=true"
import script from "./PFiles.vue?vue&type=script&lang=js"
export * from "./PFiles.vue?vue&type=script&lang=js"
import style0 from "./PFiles.vue?vue&type=style&index=0&id=3b95598a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95598a",
  null
  
)

export default component.exports